/*
 * This file is part of glowingblue/password-strength.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import extractText from 'flarum/common/utils/extractText';
import EyeButton from './EyeButton';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
export default class LogInPasswordField extends Component {
  view() {
    const {
      parent_this,
      showingPassword
    } = this.attrs;
    const passwordLabel = extractText(t('core.forum.log_in.password_placeholder'));
    return (
      // This replaces the `password` field rendered by core's `LogInModal`
      // (flarum/forum/components/LogInModal#fields). Keep the input's
      // attributes in sync with core; the only additions are the `togglable`
      // class, the visibility-aware `type`, and the EyeButton.
      m("div", {
        className: "Form-group PasswordField"
      }, m("input", {
        className: "FormControl togglable",
        name: "password",
        type: showingPassword() ? 'text' : 'password',
        autocomplete: "current-password",
        placeholder: passwordLabel,
        "aria-label": passwordLabel,
        bidi: parent_this.password,
        disabled: parent_this.loading
      }), m(EyeButton, {
        showing: showingPassword
      }))
    );
  }
}
flarum.reg.add('glowingblue-password-strength', 'forum/components/LogInPasswordField', LogInPasswordField);